var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.96028,
    cy: 16.1048,
    r: 2.96028,
    fill: "#9A9A9A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.92563 2C19.1814 2.00002 15.1016 11.3858 19.8513 15.4083C16.5103 15.4083 4.31622 15.4083 0 15.4083C3.7145 11.8124 1 1.99998 9.92563 2Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.f26483f90c20ce042be9aeb4a967d04d.svg";
export { ForwardRef as ReactComponent };